import {
    useIsUserAMember,
    useIsUserAuthenticated,
    useIsUserCompany,
} from '../../common/hooks/useUserProfile';
import { getBloomreachId } from '../../common/utils/bloomreachIdUtils';

export const useIsEligibleForNewBonusSystem = () => {
    const isMember = useIsUserAMember();
    const isCompany = useIsUserCompany();
    const isAuthenticated = useIsUserAuthenticated();

    const beId = (!isMember && getBloomreachId()) || undefined;
    const isEligibleForNewBonusSystem = !!isMember && !!isAuthenticated && !isCompany;

    return {
        beId,
        isAuthenticated,
        isEligibleForNewBonusSystem,
    };
};
